module.exports = __webpack_public_path__ + "static/media/aboutUs2.4c0adb7c.jpg";